import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  LIStyled,
  ULStyled,
} from './styles';

const listDataArray = [
  'Financial Planning',
  <>Investment Planning &#38; Strategies</>,
  'Advanced Portfolio Management',
  <>Retirement Planning &#38; Income Strategies</>,
  <>Estate Planning &#38; Trust Services</>,
  'Risk Management',
  <>Tax&#45;Efficient Strategies</>,
  'Advisor Coordination',
  <>Business Planning &#38; Succession</>,
  'Multigenerational Planning',
  'Charitable Planning',
  'Education Funding',
];

export default () => {

  return (
    <SectionContainer
      id='private-wealth-management-our-services'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row>
        <Col>
          <Typography
            component='h2'
            accent='pcgHeading'
            branding='pcg'
            align='center'
            disableBottomPadding>
            Our services, <WidowBlock>tailored to you</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col>
          <ULStyled>
            {(
              listDataArray.map((item, index) => (
                <LIStyled key={`list-item-${index + 1}`}>
                  <Typography disableBottomPadding>
                    {item}
                  </Typography>
                </LIStyled>
              ),
              )
            )}
          </ULStyled>
        </Col>
      </Row>
    </SectionContainer>
  );
};
